export default [
    {
        path: '/user/discuss',
        name: 'mydiscuss',
        meta: {
            title: '我的话题'
        },
        component: () => import('./MyDiscuss')
    }
]